"use client";
import { Box, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import hipaa from "@/assets/hipaa.png";
import soc2 from "@/assets/soc-2.png";
import bbb from "@/assets/bbb.png";
import { useSearchParams } from "next/navigation";
import { JoinThousands } from "../landing/JoinThousands";

const WelcomeMessage = () => {
  const searchParams = useSearchParams();
  const id = searchParams.get("id") || "";
  const eId = searchParams.get("eid") || "";

  return (
    <VStack
      flex="1"
      bg="#FFEFD1"
      justifyContent="space-between"
      alignItems="flex-start"
      h="100vh"
      p={{
        base: "20px",
        md: "48px",
      }}
    >
      <Link href="/">
        <Image
          src={`/api/logo-proxy?id=${eId}`}
          width={120}
          height={120}
          alt="Mindset"
        />
      </Link>

      <Box>
        <Heading
          as="h1"
          fontWeight="800"
          mt="24px"
          mb="12px"
          fontSize={{
            base: "28px",
            md: "52px",
          }}
          lineHeight={{
            base: "auto",
            md: "72px",
          }}
          color="brand.secondary"
        >
          {id
            ? "Thank you for entering your information!"
            : "See if you are pre-qualified for disability benefits!"}
        </Heading>
        <Text
          as="p"
          color="#3D565F"
          fontSize="18px"
          fontWeight="500"
          lineHeight="24px"
        >
          Take this quick 1-minute survey to see if you qualify for Social
          Security Disability benefits.
        </Text>
      </Box>
      <HStack alignItems="center">
        <JoinThousands />
        <HStack gap="12px" hideBelow="lg">
          <Image src={hipaa} alt="HIPAA" height={48} />
          {
            // <Image src={soc2} alt="SOC 2" height={48} />
          }
          <Image src={bbb} alt="BBB" height={48} />
        </HStack>
      </HStack>
    </VStack>
  );
};

export default WelcomeMessage;
